import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/inbox/read-status/bulk']['PUT'];

type Input = ThisApi['body'];

const bulkChangeReadStatus = async ({ inboxItemIds, isRead }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put<ThisApi['response']>('/inbox/read-status/bulk', {
    inboxItemIds,
    isRead,
  });
  return response.data;
};

export default bulkChangeReadStatus;
